import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  label: {
    marginBottom: 6,
    color: '#071B27',
    textTransform: 'uppercase',
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '0.035em'
  },
  inputRootFocused: {
    boxShadow: '0 0 3px 3px rgba(65, 183, 215, 0.35)',
    border: '1px solid #41B7D7'
  },
  input: {
    outline: 0,
    padding: '8px 10px',
    fontSize: '13px',
    lineHeight: '18px',
    borderRadius: '3px',
    border: '1px solid #BECEDA',
    '&:hover': {
      border: '1px solid #41B7D7'
    },
    '&:focus': {
      boxShadow: '0 0 3px 3px rgba(65, 183, 215, 0.35)',
      border: '1px solid #41B7D7'
    }
  },
  error: {
    boxShadow: 'none',
    border: '1px solid #EB5757',
    '&:hover': {
      border: '1px solid #EB5757'
    },
    '&:focus': {
      boxShadow: 'none',
      border: '1px solid #EB5757'
    }
  },
  disabledInput: {
    backgroundColor: '#F1F1F1',
    color: '#838383'
  },
  disabledLabel: {
    color: '#838383'
  }
});
